var currencyDivisors = {
  USD: 100, // US Dollar
  EUR: 100, // Euro
  GBP: 100, // British Pound
  AUD: 100, // Australian Dollar
  CAD: 100, // Canadian Dollar
  CHF: 100, // Swiss Franc
  CNY: 100, // Chinese Yuan
  JPY: 1, // Japanese Yen
  KRW: 1, // South Korean Won
  INR: 100, // Indian Rupee
  RUB: 100, // Russian Ruble
  BRL: 100, // Brazilian Real
  MXN: 100, // Mexican Peso
  ZAR: 100, // South African Rand
  NZD: 100, // New Zealand Dollar
  SEK: 100, // Swedish Krona
  NOK: 100, // Norwegian Krone
  DKK: 100, // Danish Krone
  PLN: 100, // Polish Złoty
  HKD: 100, // Hong Kong Dollar
  SGD: 100, // Singapore Dollar
  THB: 100, // Thai Baht
  TWD: 100, // New Taiwan Dollar
  TRY: 100, // Turkish Lira
  MYR: 100, // Malaysian Ringgit
  IDR: 100, // Indonesian Rupiah (in most stores it might be in hundreds of rupiah)
  PHP: 100, // Philippine Peso
  AED: 100, // UAE Dirham
  SAR: 100, // Saudi Riyal
  CZK: 100, // Czech Koruna
  HUF: 100, // Hungarian Forint
  ILS: 100, // Israeli New Shekel
  VND: 1, // Vietnamese Dong (no cents)
  KZT: 100, // Kazakhstani Tenge
  NGN: 100, // Nigerian Naira
  ARS: 100, // Argentine Peso
  CLP: 1, // Chilean Peso (no cents)
  COP: 100, // Colombian Peso
  PEN: 100, // Peruvian Sol
  PKR: 100, // Pakistani Rupee
  EGP: 100, // Egyptian Pound
  QAR: 100, // Qatari Riyal
  KWD: 1000, // Kuwaiti Dinar (three decimal places)
  BHD: 1000, // Bahraini Dinar (three decimal places)
  OMR: 1000, // Omani Rial (three decimal places)
  JOD: 1000, // Jordanian Dinar (three decimal places)
};
